<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header :header-title="pageTitle" />
      <form-agent-multi-account :is-submitting="uiFlags.isUpdating" :value="agent" @submit="onSubmit" @cancel="onClose"/>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import FormAgentMultiAccount from './FormAgentMultiAccount';

export default {
  components: {
    FormAgentMultiAccount,
  },
  props: {
    agent: {
      type: Object,
      required: true,
    },
    onClose: { type: Function, required: true },
  },
  data() {
    return {
      show: true
    };
  }, 
  computed: {
    pageTitle() {
      return `${this.$t('AGENT_MGMT.EDIT.TITLE')}`;
    },
    ...mapGetters({
      uiFlags: 'agents/getUIFlags',      
    })
  },
  methods: {    
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
    async onSubmit(dataAgent) {
      try {
        delete dataAgent.email;
        await this.$store.dispatch('agents/update', {...dataAgent, id: this.agent.id});
        this.showAlert(this.$t('AGENT_MGMT.EDIT.API.SUCCESS_MESSAGE'));
        this.onClose(true);
      } catch (error) {
        console.log(error.message);
        this.showAlert(this.$t('AGENT_MGMT.EDIT.API.ERROR_MESSAGE'));
      }
    }    
  },
};
</script>